import { KeepTogether } from '../../../../../../../components/ui-components/KeepTogether'

export function HeaderInfoIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className="shrink-0" aria-hidden>
      <path
        d="M7 1.75C4.1005 1.75 1.75 4.1005 1.75 7C1.75 9.8995 4.1005 12.25 7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.1005 9.8995 1.75 7 1.75ZM7 13.125C3.617 13.125 0.875 10.383 0.875 7C0.875 3.617 3.617 0.875 7 0.875C10.383 0.875 13.125 3.617 13.125 7C13.125 10.383 10.383 13.125 7 13.125Z"
        fill="#8E9393"
      />
      <path d="M6.125 6.125H7.4375V10.0625H6.125V6.125Z" fill="#8E9393" />
      <path d="M6.125 3.9375H7.4375V5.25H6.125V3.9375Z" fill="#8E9393" />
    </svg>
  )
}

/** Trailing word + info icon. Wraps as one unit when the summary line breaks. */
export function HeaderInfoAfterWord({ word }: { word: string }) {
  return (
    <KeepTogether>
      {word}{' '}
      {/* relative + top shifts paint only — margin-top would grow the nowrap line box */}
      <span className="relative top-[2.5px] inline-flex">
        <HeaderInfoIcon />
      </span>
    </KeepTogether>
  )
}
